import { Box, Flex, Text, Button, Heading, IconButton, Grid, Card, Link, Separator, AlertDialog } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Info } from 'luxon';
import { getTeacherCourses } from '../../api/courses';
import ScheduleForm from '../forms/ScheduleForm';
import QuizCreator from '../forms/teacher/ContentCreator';
// import { updateAccountCourses } from '../../redux/slices/accountSlice';
import { updateTeacherCourses } from '../../redux/slices/teacherAccountSlice';
import TeacherPeriods from '../teacher/TeacherPeriods';
import TeacherCourseList from './TeacherCourseList';

const TeacherSchedule = () => {
    const [selectedDay, setSelectedDay] = useState('');
    // const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [showQuizCreator, setShowQuizCreator] = useState(false);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const user = useSelector(state => state.user);
    const account = useSelector(state => state.teacherAccount);
    const dispatch = useDispatch();
    const courses = account.courses;

    const fetchCourses = async () => {
        const fetchedCourses = await getTeacherCourses(account.details.id);
        // setCourses(fetchedCourses.courses);
        // console.log('fetching new courses::', fetchedCourses.courses);
        dispatch(updateTeacherCourses(fetchedCourses.courses));
    };

    useEffect(() => {
        fetchCourses();
        setFilteredCourses(courses)
    }, []);

    useEffect(() => {
        setFilteredCourses(selectedDay ?
            courses.filter(course => course.schedules.some(schedule => schedule.day === Info.weekdays('short').indexOf(selectedDay)))
            :
            courses
        );
    }, [courses]);

    const handleCreateQuiz = (course) => {
        setSelectedCourse(course);
        setShowQuizCreator(true);
    };

    const handleCourseSelect = (course) => {
        setSelectedCourse(course);
        // console.log('selectedCourse::', selectedCourse);
    };

    return (
        <Box width="100%">
            <Grid 
                columns={{ initial: '1', sm: '2' }} 
                rows="auto" 
                gap="4"
            >
                <Box gridColumn={{ initial: '1', sm: '1 / span 1' }} gridRow={{ initial: '2', sm: '2' }} height="100%">
                    <Card style={{ height: '100%' }}>
                        <Heading size="3" as="h3" mb="4">Courses</Heading>
                        <TeacherCourseList courses={courses} onCourseSelect={handleCourseSelect} selectedCourse={selectedCourse} />
                    </Card>
                </Box>
                
                <Box gridColumn={{ initial: '1', sm: '2' }} gridRow={{ initial: '3', sm: '2' }} height="100%">
                    <Card style={{ height: '100%' }}>
                        <Flex direction="column" gap="4" align="start" justify="start">
                            <TeacherPeriods />
                        </Flex>
                    </Card>
                </Box>
                
                <Box gridColumn= {{initial: '1', sm: '1 / span 2'} } gridRow={{ initial: '1', sm: '1'}}>
                    <Card>
                        <ScheduleForm courses={courses} fetchCourses={fetchCourses} selectedCourse={selectedCourse} />
                    </Card>
                </Box>
            </Grid>
            <AlertDialog.Root open={showQuizCreator} onOpenChange={setShowQuizCreator}>
                <AlertDialog.Content style={{ maxWidth: 600 }}>
                    {/* <AlertDialog.Title>Create Quiz</AlertDialog.Title> */}
                    <AlertDialog.Description size="2">
                        Create a quiz for this course
                    </AlertDialog.Description>
                    <QuizCreator course={selectedCourse} />
                    <Flex gap="3" mt="4" justify="end">
                        <AlertDialog.Cancel>
                            <Button variant="soft" color="gray">
                                Cancel
                            </Button>
                        </AlertDialog.Cancel>
                    </Flex>
                </AlertDialog.Content>
            </AlertDialog.Root>
        </Box>
    );
};

export default TeacherSchedule;
